var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-overlay",on:{"click":function($event){$event.preventDefault();return _vm.closeMobileMenu($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }